import type { ReactElement } from "react";

import { StartSiteAsk } from "./StartSiteAsk";

export function FinalCta(): ReactElement {
  return (
    <section className="border-t border-[#d9e3e0] px-5 pb-28 pt-24 sm:px-8 sm:pb-36 sm:pt-32">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="marketing-display mx-auto max-w-4xl text-5xl leading-[1.06] text-[#101d1a] sm:text-7xl">
          Get your site. Keep it current.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-[#596763]">
          14 days free. Then from $25 a month. Cancel anytime.
        </p>
        <div className="mx-auto mt-12 w-full max-w-2xl text-left">
          <StartSiteAsk
            id="final-start-site"
            placeholder="What kind of site do you need?"
          />
        </div>
      </div>
    </section>
  );
}
